(function () {
  if (typeof jQuery === 'undefined') return;
  var $ = jQuery;
  if (!$.fn || !$.fn.slick) return;

  $('.mv-slider').slick({
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: true,
  });

  $('.iv02-slider').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipe: false,
    arrows: false,
    lazyLoad: 'ondemand',
    cssEase: 'linear',
    useTransform: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 836,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  });

  $('.iv03-slider').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipe: false,
    arrows: false,
    lazyLoad: 'ondemand',
    cssEase: 'linear',
    useTransform: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 836,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  });
})();
